import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';

import amber from '@material-ui/core/colors/amber';

import { WebsiteTestimonialCard } from '../Testimonials';
import Illustration from 'components/Illustration';

const styles = theme => ({
  root: {

  },
  button: {
    backgroundColor: amber[500],
    color: "#fff",
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },
});

const WebsiteTestimonialCards = ({ classes, testimonials, handleDialog }) => {
  return(
    <div>
      <div className={classes.header}>
        <div>
          <Typography variant="headline">
            Testimonials
          </Typography>
          <Typography variant="caption">
            Your testimonials add credibility to your reputation.
          </Typography>
        </div>
        <Button
          className={classes.button}
          variant="fab"
          aria-label="add"
          onClick={() => handleDialog({ show: true })}
          >
          <AddIcon />
        </Button>
      </div>
      <div className={classes.content}>
        {testimonials.length > 0 &&
          testimonials.map((testimonial, i) => {
            return <WebsiteTestimonialCard
                      key={i}
                      testimonial={testimonial}
                      handleDialog={handleDialog}
                    />
          })
        }
        {testimonials.length === 0 &&
          <Illustration
            imgKey="hiring_amber"
            explainerText="You've done some great work that people love. Go get testimonials from them and let others know your value."
            addItemText="Let’s get them entered by clicking the “Floating Action Button” at top right."
          />
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const testimonials = state.websiteState.testimonials;

  return({
    testimonials
  });
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(WebsiteTestimonialCards);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Testimonials/WebsiteTestimonialCards.jsx